module.exports = __webpack_public_path__ + "media/images/brain-landing-f1a8645bdf254b61cb16761abab7d250.png";